import httpRequest from "@/shared/services/httpRequest";
import { StandardResponse } from "@/shared/services/response.model";
import { API_ENDPOINTS } from "@/shared/constants";
import {
  DataValidationNotificationResponse,
  UpdateDataValidationNotificationStatusRequest,
  UpdateDataValidationNotificationStatusResponse,
} from "../types/DataValidationNotification.type";

export const getPendingDataValidationNotifications = async (): Promise<
  StandardResponse<DataValidationNotificationResponse["data"]>
> => {
  return await httpRequest.get<DataValidationNotificationResponse["data"]>(
    API_ENDPOINTS.reports.dataValidation.notifications.pending,
  );
};

export const updateDataValidationNotificationStatus = async (
  request: UpdateDataValidationNotificationStatusRequest,
): Promise<
  StandardResponse<UpdateDataValidationNotificationStatusResponse["data"]>
> => {
  return await httpRequest.patch<
    UpdateDataValidationNotificationStatusResponse["data"],
    UpdateDataValidationNotificationStatusRequest
  >(API_ENDPOINTS.reports.dataValidation.notifications.updateStatus, request);
};
